import {Form} from '../../../application/forms/form';

class SubscriptionForm extends Form
{
    get data() {
        return {email: this.container.querySelector('[name="email"]').value};
    }
}

export {SubscriptionForm};
